import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from '../../utils/util';

@Pipe({
    name: 'kabobCase',
    standalone: true
})
export class KabobCasePipe implements PipeTransform {
  transform(value) {
    if (!isNullOrUndefined(value)) {
      return value
        .replace(/\s/g, '-')
        .toLowerCase()
        .trim();
    }
    return value;
  }
}
